/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props) {
  return function onChange(value) {
    if (typeof props.onChange !== 'function') return

    props.onChange(value)
  }
}
